import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 col-xxl-12 col-sm-6 mb-10\"><div class=\"card mb-25 border-0 rounded-0\"><div class=\"card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing\"><div class=\"card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25\"><h4 class=\"position-relative text-black fw-bold mb-10\">Informations</h4></div><table class=\"table\"><tbody></tbody></table></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}